import ContentLoader from 'react-content-loader';

export default ContentLoader;

export const Rect = 'rect';
export const Circle = 'circle';
